import { useTranslation } from 'react-i18next'
import { LinearProgressBar } from '@/UIComponents2/LinearProgressBar'

type MessageBoxFileUsageProgressbarProps = {
    value: number | null | undefined
    spaceUsed: string
    spaceTotal: string
}
export default function MessageBoxFileUsageProgressbar(props: MessageBoxFileUsageProgressbarProps) {
    const { t } = useTranslation()

    const val = props.value && isNaN(props.value) ? null : props.value

    return (
        <div className="flex flex-col gap-[12px] py-[20px] px-[20px] border-t border-t-white/5">
            <div className="flex w-full items-center justify-between">
                <div className="">{t('Storage usage:')}</div>
                <div>
                    <span>{`${props.spaceUsed} / `}</span>
                    <span className="font-light opacity-75">{props.spaceTotal}</span>
                </div>
            </div>
            <div className="flex flex-col w-full">
                <LinearProgressBar value={val || 0} />
            </div>
        </div>
    )
}
